import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 512px;
  padding: 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const CloseButton = styled.button`
  border: none;
  background: none;
  color: #55606b;
  font-size: 1.2rem;
  line-height: 1;
  padding: 4px;
  cursor: pointer;

  &:hover { color: #1b2b3a; }
`;

export const Question = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const QuestionLabel = styled.p`
  margin: 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const Answer = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: #55606b;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const MoodAnswer = styled(Answer)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MoodIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;
